<template>
  <div id="app">
    <div class="container app-content box-app p-0" style="position: relative">
      <AppLayout>
        <div v-if="updateExists" class="d-flex tap-update p-2 mt-3" style="z-index: 1000;">
          <span style="flex-grow: 1"
            >CarbonWize มีเวอร์ชันใหม่พร้อม
            <u @click="refreshApp">อัปเดต</u></span
          >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="currentColor"
            class="bi bi-x ms-auto"
            viewBox="0 0 16 16"
            @click="updateExists = false"
          >
            <path
              d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
            />
          </svg>
        </div>
        <!-- <button
          v-if="updateExists"
          class="btn btn-primary text-white"
          @click="refreshApp"
        >
          updated
        </button> -->
        <div class="main-content"></div>
        <router-view />
      </AppLayout>
    </div>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import AppLayout from "@/layouts/AppLayout";
export default {
  name: "App",
  components: {
    // HelloWorld
    AppLayout,
  },
  data() {
    return {
      prompt: false,
      registration: null,
      updateExists: false,
      refreshing: false,
    };
  },
  created() {
    document.addEventListener("swUpdated", this.updateAvailable, {
      once: true,
    });
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      console.log("controler change");
      // We'll also need to add 'refreshing' to our data originally set to false.
      if (this.refreshing) return;
      this.refreshing = true;
      // Here the actual reload of the page occurs
      window.location.reload();
    });

    // if (this.$workbox) {
    //   // this.$workbox.addEventListener("waiting",this.testEvent())
    //   this.$workbox.addEventListener("waiting", () => {
    //     this.prompt = true;
    //     this.update()

    //   });
    // }
  },
  methods: {
    updateAvailable(event) {
      this.registration = event.detail;
      this.updateExists = true;
    },
    refreshApp() {
      this.updateExists = false;
      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (!this.registration || !this.registration.waiting) return;
      // Send message to SW to skip the waiting and activate the new SW
      this.registration.waiting.postMessage({ type: "SKIP_WAITING" });
    },
    // async update() {
    //   this.prompt = false;
    //   await this.$workbox.messageSW({ type: "SKIP_WAITING" });
    // },
  },
};
</script>

<style>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  /* font-family: 'Roboto'; */
  font-family: "Noto Sans Thai", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}

@media (min-width: 992px) {
  #app {
    background: #fbfcff;
  }
}

.app-content {
  min-height: 100vh !important;
}

.box-app {
  width: 100%;
  /* background: white; */
  background: #fbfcff;
  height: 100%;
  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
}

.tap-update {
  background-color: #4db670 !important;
  position: absolute;
  width: 100%;
  left: 0px;
  color: white;
}
</style>
